export const FixedHeaderStyle = {
  position: 'sticky',
  top: 0,
  background: 'white',
  zIndex: 1,
};
